// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  LocalizableString,
} from "./types";

export default {
  dtmi: __t.string(),
  name: __t.string(),
  targetDtmi: __t.string(),
  writable: __t.bool(),
  maxMultiplicity: __t.i32(),
  get displayName() {
    return LocalizableString;
  },
  get description() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
};
